import { Stack } from 'components/Stack';
import styled from 'styled-components';

export const CustomTextContainer = styled(Stack)`
  font-size: 14px;
  line-height: 21px;
`;
